import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAsyncFn } from 'react-use';
import { isAllOffersProduct, isAllOffersProductWithOffer } from '@uno/common-cms';
import Loader from 'components/common/Loader';
import { useSiteConfig, useSnackAsyncError } from 'libs/common/hooks';
import { getAffiliationProducts } from 'services/networking/affiliation';
import AffiliationWarning from '../AffiliationWarning/AffiliationWarning';
import { AffiliationPriceTable, AffiliationPriceTableImage, AffiliationPriceTableImageContainer, AffiliationPriceTableOffer, AffiliationPriceTableOfferPrice, AffiliationPriceTableOfferRetailer, AffiliationPriceTableOffers, AffiliationPriceTableOffersContainer, AffiliationPriceTableTitle, AffiliationPriceTableWarning, LoaderContainer, NoOffer } from './AffiliationBlockPriceTable.style';

var AffiliationBlockPriceTable = function AffiliationBlockPriceTable(_ref) {
  var _entityData$products, _entityData$products$, _entityData$products$2, _entityData$title, _entityData$title2;

  var entityData = _ref.entityData;
  var intl = useIntl();

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id,
      lang = _useSiteConfig.lang;

  var _useSnackAsyncError = useSnackAsyncError(),
      snackAsyncError = _useSnackAsyncError.snackAsyncError;

  var _useState = useState(undefined),
      selectedProduct = _useState[0],
      setSelectedProduct = _useState[1];

  var _useAsyncFn = useAsyncFn( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(affiliationId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(selectedProduct !== undefined)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return snackAsyncError({
                messageId: 'affiliation.error.get-products',
                callback: function () {
                  var _callback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _yield$getAffiliation, products;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return getAffiliationProducts(lang, affiliationId, site);

                          case 2:
                            _yield$getAffiliation = _context.sent;
                            products = _yield$getAffiliation.products;

                            if (products[0] !== undefined) {
                              setSelectedProduct(products[0]);
                            }

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  function callback() {
                    return _callback.apply(this, arguments);
                  }

                  return callback;
                }()
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }()),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      retrieveProductLoading = _useAsyncFn2[0].loading,
      retrieveProduct = _useAsyncFn2[1];

  useEffect(function () {
    if ((entityData === null || entityData === void 0 ? void 0 : entityData.affiliationId) === undefined) {
      return;
    }

    void retrieveProduct(entityData.affiliationId);
  }, [entityData, retrieveProduct]);

  var PriceTable = function PriceTable() {
    var _selectedProduct$maxD;

    if (selectedProduct === undefined || !isAllOffersProduct(selectedProduct)) {
      return __jsx(FormattedMessage, {
        id: 'affiliation.invalid'
      });
    }

    var Offer = function Offer(_ref3) {
      var offer = _ref3.offer;

      if (offer === undefined) {
        return __jsx(AffiliationPriceTableOffer, null, __jsx(AffiliationPriceTableOfferRetailer, null, __jsx(FormattedMessage, {
          id: 'affiliation-table-modal.no-offer',
          tagName: NoOffer
        })));
      }

      return __jsx(AffiliationPriceTableOffer, null, __jsx(AffiliationPriceTableOfferRetailer, null, offer.storeName), __jsx(AffiliationPriceTableOfferPrice, {
        className: "retailerPrice"
      }, offer.price, "\u20AC"));
    };

    return __jsx(AffiliationPriceTableOffersContainer, null, __jsx(AffiliationPriceTableOffers, null, isAllOffersProductWithOffer(selectedProduct) ? __jsx(React.Fragment, null, selectedProduct.offers.slice(0, (_selectedProduct$maxD = selectedProduct.maxDisplayedOffers) !== null && _selectedProduct$maxD !== void 0 ? _selectedProduct$maxD : 1).map(function (offer) {
      return __jsx(Offer, {
        offer: offer,
        key: offer.url
      });
    })) : __jsx(Offer, null)));
  };

  var affiliationIsBroken = !retrieveProductLoading && !isAllOffersProductWithOffer(selectedProduct);
  var imgUrl = (_entityData$products = entityData.products) === null || _entityData$products === void 0 ? void 0 : (_entityData$products$ = _entityData$products[0]) === null || _entityData$products$ === void 0 ? void 0 : (_entityData$products$2 = _entityData$products$.image) === null || _entityData$products$2 === void 0 ? void 0 : _entityData$products$2.imgUrl;
  return __jsx(AffiliationPriceTable, null, __jsx(AffiliationPriceTableTitle, null, (_entityData$title = entityData.title) !== null && _entityData$title !== void 0 ? _entityData$title : intl.formatMessage({
    id: 'affiliation-table-modal.labels.tableTitle'
  })), __jsx(AffiliationPriceTableImageContainer, {
    isBroken: affiliationIsBroken
  }, affiliationIsBroken && __jsx(AffiliationPriceTableWarning, null, __jsx(AffiliationWarning, {
    messageId: 'affiliation.obsolete'
  })), imgUrl !== undefined && imgUrl !== '' && __jsx(AffiliationPriceTableImage, {
    src: imgUrl,
    alt: (_entityData$title2 = entityData.title) !== null && _entityData$title2 !== void 0 ? _entityData$title2 : intl.formatMessage({
      id: 'affiliation-table-modal.labels.tableTitle'
    })
  })), retrieveProductLoading ? __jsx(LoaderContainer, null, __jsx(Loader, null)) : __jsx(PriceTable, null));
};

export default AffiliationBlockPriceTable;